/* ezink-print-live-v3.js — range banners: W×H area $/sqft (banner_price.sqft_retail) + finish_mult; Size(ft) for cart line. */
(function (w) {
  function adjustVariant() {
    var n = Number(w.EZINK_PRINT_ADJUST_VARIANT || 0);
    return n > 0 ? n : 0;
  }

  function moneyFormat(root) {
    var wrap = root && root.querySelector("[data-ezink-price-wrap]");
    return (wrap && wrap.getAttribute("data-money-format")) || "${{amount}}";
  }

  function formatMoney(cents, fmt) {
    cents = Math.round(Number(cents) || 0);
    var d = (Math.abs(cents) / 100).toFixed(2);
    var out = String(fmt || "${{amount}}")
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Math.abs(cents) / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, d.replace(".", ","))
      .replace(/\{\{\s*amount\s*\}\}/g, d);
    if (out === (fmt || "${{amount}}")) out = "$" + d;
    return (cents < 0 ? "-" : "") + out;
  }

  function parsePayload(root) {
    var node = root.querySelector("[data-ezink-print-combo-json]");
    if (!node) return null;
    var payload;
    try {
      payload = JSON.parse(node.textContent || "{}");
    } catch (err) {
      return null;
    }
    var pricesNode = root.querySelector("[data-ezink-print-prices-json]");
    if (pricesNode) {
      try {
        payload.price_pack = JSON.parse(pricesNode.textContent || "{}");
      } catch (err2) {
        payload.price_pack = null;
      }
    }
    return payload;
  }

  function normSize(v) {
    return String(v || "")
      .toLowerCase()
      .replace(/["'″]/g, "")
      .replace(/[×x]/g, "x")
      .replace(/\s+/g, "")
      .replace(/x+/g, "x");
  }

  function normCombo(key, v) {
    v = String(v || "").replace(/\s+/g, " ").trim();
    if (key === "Size") return normSize(v);
    var t = v.toLowerCase();
    if (key === "Drill Hole") {
      if (!t || t.indexOf("no hole") !== -1 || t.indexOf("no drill") !== -1) return "";
    }
    if (key === "Folding Options") {
      if (!t || t.indexOf("no fold") !== -1 || t.indexOf("flat") === 0) return "";
    }
    if (key === "Perforation") {
      if (!t || t.indexOf("no perf") !== -1) return "";
    }
    if (key === "Numbering") {
      if (!t || t.indexOf("no number") !== -1) return "";
    }
    return v;
  }

  function fieldVal(root, name) {
    var want = String(name || "");
    var hit = "";
    root.querySelectorAll("[data-ezink-print-key]").forEach(function (el) {
      if ((el.getAttribute("data-ezink-print-key") || "") !== want) return;
      if (el.disabled) return;
      var wrap = el.closest(".ezink-print-field");
      if (wrap && wrap.classList.contains("is-combo-hidden")) return;
      hit = el.value || "";
    });
    return hit;
  }

  function comboIndex(root, payload, keyFilter) {
    var keys = payload && payload.combo_keys;
    var combos = payload && payload.combos;
    if (!keys || !combos || !combos.length) return -1;
    var sizeI = keys.indexOf("Size");
    var wantSize = sizeI >= 0 ? normCombo("Size", fieldVal(root, "Size")) : "";
    var values = {};
    keys.forEach(function (k) {
      values[k] = normCombo(k, fieldVal(root, k));
    });
    var best = -1;
    var bestScore = -1;
    for (var r = 0; r < combos.length; r++) {
      var row = combos[r];
      if (wantSize && sizeI >= 0 && normCombo("Size", row[sizeI] || "") !== wantSize) continue;
      var score = wantSize ? 50 : 0;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (key === "Size") continue;
        var have = values[key] || "";
        var cell = normCombo(key, row[i] || "");
        if (!have || !cell) continue;
        if (have === cell) score += 10;
      }
      if (score > bestScore) {
        bestScore = score;
        best = r;
      }
    }
    return best;
  }

  function lookupPacked(pack, comboIndex, qty) {
    if (!pack || comboIndex < 0 || !(qty > 0)) return 0;
    var qtys = pack.q || [];
    var rows = pack.s || [];
    var row = rows[comboIndex];
    if (!row) return 0;
    var exact = -1;
    for (var i = 0; i < qtys.length; i++) {
      if (Number(qtys[i]) === qty) {
        exact = i;
        break;
      }
    }
    if (exact >= 0 && Number(row[exact]) > 0) return Number(row[exact]);
    for (var j = 0; j < qtys.length; j++) {
      if (Number(qtys[j]) >= qty && Number(row[j]) > 0) return Number(row[j]);
    }
    for (var k = qtys.length - 1; k >= 0; k--) {
      if (Number(row[k]) > 0) return Number(row[k]);
    }
    return 0;
  }

  function selectedQty(root) {
    var qty = 0;
    var run = root.querySelector(".product-form__item--run-qty select, select[data-index='option1']");
    if (run) {
      qty = parseInt(String(run.value).replace(/,/g, ""), 10) || 0;
      if (qty > 0) return qty;
    }
    root.querySelectorAll("select.single-option-selector").forEach(function (el) {
      var wrap = el.closest(".selector-wrapper, .ezink-print-field");
      var label = wrap && wrap.querySelector("label");
      var name = ((label && label.textContent) || "").replace(/\s+/g, " ").trim().toLowerCase();
      if (name.indexOf("quantity") !== -1) {
        var n = parseInt(String(el.value).replace(/,/g, ""), 10);
        if (n > 0) qty = n;
      }
    });
    return qty > 0 ? qty : 0;
  }

  function isRush(root) {
    var pill = root.querySelector("[data-ezink-turnaround-val].is-active");
    if (pill) return (pill.getAttribute("data-ezink-turnaround-val") || "") === "Rush";
    var sel = root.querySelector("[data-ezink-turnaround] select, .product-form__item--turnaround select");
    if (sel) return String(sel.value || "") === "Rush";
    return false;
  }

  function setsQty(root) {
    var inp = root.querySelector("[data-ezink-qty-input]");
    var n = parseInt(inp && inp.value, 10);
    return n > 0 ? n : 1;
  }

  function productJsonEl(root) {
    var jsonEl = (root && root.querySelector("[data-product-json]")) || document.querySelector("[data-product-json]");
    if (jsonEl) return jsonEl;
    var sectionId = root && root.id ? String(root.id).replace(/^ProductSection-/, "") : "";
    if (sectionId) {
      jsonEl = document.getElementById("ProductJson-" + sectionId);
      if (jsonEl) return jsonEl;
    }
    return document.querySelector('script[id^="ProductJson-"]');
  }

  function productData(root) {
    var jsonEl = productJsonEl(root);
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent || "{}");
    } catch (err) {
      return null;
    }
  }

  function sizeSelectEl(root) {
    return (
      root.querySelector("[data-ezink-banner-size-select]") ||
      root.querySelector(".product-form__item--size-dropdown .single-option-selector") ||
      root.querySelector("[data-ezink-size-select]")
    );
  }

  function parseFtLabel(label) {
    if (!label) return null;
    var m = String(label)
      .replace(/\s+/g, "")
      .match(/(\d+(?:\.\d+)?)\s*['′ft]?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    return m ? { label: label, w: parseFloat(m[1]) * 12, h: parseFloat(m[2]) * 12 } : null;
  }

  function coveringSizeLabel(root) {
    var wIn = root.querySelector('input[name="properties[Width]"]');
    var hIn = root.querySelector('input[name="properties[Height]"]');
    var sizeSelect = sizeSelectEl(root);
    if (!sizeSelect || !sizeSelect.options || !sizeSelect.options.length) return "";
    var w = parseFloat(wIn && wIn.value);
    var h = parseFloat(hIn && hIn.value);
    if (!(w > 0 && h > 0)) return sizeSelect.value || "";
    var opts = [];
    var i;
    for (i = 0; i < sizeSelect.options.length; i++) {
      var parsed = parseFtLabel(sizeSelect.options[i].value);
      if (parsed) opts.push(parsed);
    }
    if (!opts.length) return sizeSelect.value || "";
    function covers(opt) {
      return (
        (opt.w + 0.05 >= w && opt.h + 0.05 >= h) ||
        (opt.w + 0.05 >= h && opt.h + 0.05 >= w)
      );
    }
    var fit = [];
    for (i = 0; i < opts.length; i++) if (covers(opts[i])) fit.push(opts[i]);
    if (fit.length) {
      fit.sort(function (a, b) {
        return a.w * a.h - b.w * b.h;
      });
      return fit[0].label;
    }
    opts.sort(function (a, b) {
      return b.w * b.h - a.w * a.h;
    });
    return opts[0].label;
  }

  function frameValue(root) {
    var sel = null;
    root.querySelectorAll("select.single-option-selector").forEach(function (el) {
      var wrap = el.closest(".selector-wrapper, .ezink-print-field");
      var label = wrap && wrap.querySelector("label");
      var name = ((label && label.textContent) || "").replace(/\s+/g, " ").trim().toLowerCase();
      if (name.indexOf("fram") !== -1 || name.indexOf("install") !== -1) sel = el;
    });
    var v = sel && sel.value ? String(sel.value) : "No";
    return v || "No";
  }

  function findVariant(data, sizeLabel, frame) {
    if (!data || !data.variants || !sizeLabel) return null;
    var i, v, hitNo = null;
    for (i = 0; i < data.variants.length; i++) {
      v = data.variants[i];
      if (String(v.option1) !== String(sizeLabel)) continue;
      if (!v.option2 || String(v.option2) === String(frame)) return v;
      if (String(v.option2) === "No") hitNo = v;
    }
    return hitNo;
  }

  function syncBannerVariant(root) {
    var data = productData(root);
    var sizeLabel = coveringSizeLabel(root);
    if (!sizeLabel) return null;
    var sizeSelect = sizeSelectEl(root);
    if (sizeSelect && sizeSelect.value !== sizeLabel) {
      sizeSelect.value = sizeLabel;
      try {
        sizeSelect.dispatchEvent(new Event("change", { bubbles: true }));
      } catch (err1) {}
      if (w.jQuery) {
        try {
          w.jQuery(sizeSelect).trigger("change");
        } catch (err2) {}
      }
    }
    var variant = findVariant(data, sizeLabel, frameValue(root));
    if (!variant) return null;
    var prodSel = root.querySelector("[data-product-select]") || root.querySelector("select[name='id']");
    if (prodSel && String(prodSel.value) !== String(variant.id)) {
      prodSel.value = String(variant.id);
      try {
        prodSel.dispatchEvent(new Event("change", { bubbles: true }));
      } catch (err3) {}
    }
    return variant;
  }

  function variantCents(root) {
    var data = productData(root);
    var sizeLabel = coveringSizeLabel(root);
    var matched = findVariant(data, sizeLabel, frameValue(root));
    if (matched && Number(matched.price) > 0) return Number(matched.price);
    var sel = root.querySelector("[data-product-select]") || root.querySelector("select[name='id']");
    var id = sel && sel.value;
    if (data && data.variants && id) {
      var n = parseInt(id, 10);
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].id === n) return Number(data.variants[i].price) || 0;
      }
    }
    return 0;
  }

  function hasLadder(root) {
    var payload = parsePayload(root);
    var pack = payload && payload.price_pack;
    return !!(pack && pack.s && pack.s.length && payload.combos && payload.combos.length);
  }

  /* Keep in sync with ezink/print_quote.py (finish_mult / colorspec_mult). */
  function finishMult(val) {
    var t = String(val || "")
      .toLowerCase()
      .replace(/\+/g, " + ")
      .replace(/\s+/g, " ")
      .trim();
    if (!t) return 1;
    if (t.indexOf("pole pocket") !== -1) return 1.18;
    return 1;
  }

  function colorspecMult(val, banner) {
    if (!banner) return 1;
    var t = String(val || "")
      .toLowerCase()
      .replace(/\+/g, " + ")
      .replace(/\s+/g, " ")
      .trim();
    if (!t) return 1;
    var compact = t.replace(/\s+/g, "");
    if (t.indexOf("front + back") !== -1 || compact.indexOf("front+back") !== -1 || t.indexOf("both side") !== -1) {
      return 2;
    }
    return 1;
  }

  function isBannerQuote(root) {
    var tags = (root.getAttribute("data-ezink-tags") || "").toLowerCase();
    if (tags.indexOf("banner") !== -1) return true;
    if (root.querySelector('[data-ezink-print-key="Finish Options"]')) return true;
    return false;
  }

  /* Keep in sync with ezink/banner_price.py BANNER_SQFT_RATE / material_mult / sqft_retail. */
  var BANNER_SQFT_RATE = [
    [2.0, 8.5],
    [8.0, 4.875],
    [16.0, 3.9375],
    [32.0, 3.46875],
    [48.0, 3.3125],
    [80.0, 3.1875],
    [100.0, 3.15],
    [256.0, 3.0]
  ];

  function interpBannerRate(sqft) {
    var points = BANNER_SQFT_RATE;
    if (sqft <= points[0][0]) return points[0][1];
    var i, s0, r0, s1, r1, t;
    for (i = 1; i < points.length; i++) {
      s0 = points[i - 1][0];
      r0 = points[i - 1][1];
      s1 = points[i][0];
      r1 = points[i][1];
      if (sqft <= s1) {
        t = s1 !== s0 ? (sqft - s0) / (s1 - s0) : 0;
        return r0 + t * (r1 - r0);
      }
    }
    return points[points.length - 1][1];
  }

  function materialMult(handle, title) {
    var text = String(handle || "") + " " + String(title || "");
    text = text.toLowerCase();
    if (text.indexOf("foam") !== -1) return 0.65;
    if (text.indexOf("coroplast") !== -1 || text.indexOf("coro") !== -1) return 0.85;
    if (text.indexOf("cling") !== -1 || text.indexOf("perf") !== -1 || text.indexOf("window") !== -1) return 1.85;
    if (text.indexOf("decal") !== -1 || text.indexOf("sticker") !== -1) return 2.55;
    if (text.indexOf("fabric") !== -1 || text.indexOf("polyester") !== -1 || text.indexOf("stretch") !== -1) return 1.48;
    if (text.indexOf("mesh") !== -1) return 1.05;
    if (
      text.indexOf("acrylic") !== -1 ||
      text.indexOf("aluminum") !== -1 ||
      text.indexOf("aluminium") !== -1 ||
      text.indexOf("gator") !== -1
    ) {
      return 1.35;
    }
    if (text.indexOf("canvas") !== -1) return 1.25;
    if (text.indexOf("double") !== -1) return 2;
    return 1;
  }

  function sqftRetailCents(widthIn, heightIn, handle, title) {
    var sqft = Math.max(0.25, (Number(widthIn) * Number(heightIn)) / 144.0);
    var rate = interpBannerRate(sqft) * materialMult(handle, title);
    var unitCents = Math.round(rate * sqft * 100);
    var floor = 3600;
    return unitCents >= floor ? unitCents : floor;
  }

  var KIT_BANNER_NEEDLES = [
    "retractable",
    "feather",
    "teardrop",
    "tear-drop",
    "street-pole",
    "street pole",
    "banner-stand",
    "banner stand",
    "hardware",
    "canopy",
    "tabletop",
    "tube-display",
    "seg-frame",
    "led-banner",
    "led-frame",
    "x-style",
    "pole-flag",
    "pole flags",
    "flag-hardware",
    "step-repeat",
    "real-estate-post",
    "standoff",
    "telescopic",
    "bracket",
    "wall-mount"
  ];

  function isRangeBannerArea(root) {
    if (!root) return false;
    var wIn = root.querySelector('input[name="properties[Width]"]');
    var hIn = root.querySelector('input[name="properties[Height]"]');
    if (!wIn || !hIn) return false;
    var handle = (root.getAttribute("data-product-handle") || "").toLowerCase();
    var tags = (root.getAttribute("data-ezink-tags") || "").toLowerCase();
    var title = (root.getAttribute("data-ezink-title") || "").toLowerCase();
    var blob = handle + " " + tags + " " + title;
    var i;
    for (i = 0; i < KIT_BANNER_NEEDLES.length; i++) {
      if (blob.indexOf(KIT_BANNER_NEEDLES[i]) !== -1) return false;
    }
    if (tags.indexOf("flag") !== -1 && tags.indexOf("banner") === -1) return false;
    if (handle.indexOf("flag") !== -1 && handle.indexOf("banner") === -1) return false;
    if (tags.indexOf("banner") !== -1) return true;
    if (handle.indexOf("banner") !== -1) return true;
    if (root.querySelector('[data-ezink-print-key="Finish Options"]')) return true;
    return false;
  }

  function whInches(root) {
    var wIn = root.querySelector('input[name="properties[Width]"]');
    var hIn = root.querySelector('input[name="properties[Height]"]');
    var w = parseFloat(wIn && wIn.value);
    var h = parseFloat(hIn && hIn.value);
    if (!(w > 0 && h > 0)) return null;
    return { w: w, h: h };
  }

  function areaBaseCents(root) {
    var wh = whInches(root);
    if (!wh) return 0;
    var handle = root.getAttribute("data-product-handle") || "";
    var title = root.getAttribute("data-ezink-title") || "";
    return sqftRetailCents(wh.w, wh.h, handle, title);
  }

  function cheapestVariantCents(root) {
    var data = productData(root);
    if (!data || !data.variants || !data.variants.length) return 0;
    var frame = frameValue(root);
    var best = 0;
    var i, v, price;
    for (i = 0; i < data.variants.length; i++) {
      v = data.variants[i];
      if (v.option2 && String(v.option2) !== String(frame) && String(v.option2) !== "No") continue;
      price = Number(v.price) || 0;
      if (price > 0 && (best === 0 || price < best)) best = price;
    }
    if (best > 0) return best;
    for (i = 0; i < data.variants.length; i++) {
      price = Number(data.variants[i].price) || 0;
      if (price > 0 && (best === 0 || price < best)) best = price;
    }
    return best;
  }

  function syncCheapestVariant(root) {
    var data = productData(root);
    if (!data || !data.variants) return null;
    var frame = frameValue(root);
    var best = null;
    var i, v, price;
    for (i = 0; i < data.variants.length; i++) {
      v = data.variants[i];
      if (v.option2 && String(v.option2) !== String(frame) && String(v.option2) !== "No") continue;
      price = Number(v.price) || 0;
      if (price > 0 && (!best || price < Number(best.price))) best = v;
    }
    if (!best) return null;
    var prodSel = root.querySelector("[data-product-select]") || root.querySelector("select[name='id']");
    if (prodSel) prodSel.value = String(best.id);
    return best;
  }

  function specMult(root) {
    var finish = fieldVal(root, "Finish Options");
    var colorspec = fieldVal(root, "Colorspec");
    return finishMult(finish) * colorspecMult(colorspec, isBannerQuote(root));
  }

  function quoteCents(root) {
    var payload = parsePayload(root);
    var sets = setsQty(root);
    if (payload && payload.price_pack && payload.price_pack.s && payload.price_pack.s.length) {
      var idx = comboIndex(root, payload);
      var qty = selectedQty(root);
      var cents = lookupPacked(payload.price_pack, idx, qty);
      if (cents > 0) {
        if (isRush(root)) cents *= 2;
        return cents * sets;
      }
      return 0;
    }
    var base = 0;
    if (isRangeBannerArea(root)) {
      base = areaBaseCents(root);
    }
    if (!(base > 0)) base = variantCents(root);
    if (!(base > 0)) return 0;
    base = Math.round(base * specMult(root));
    return base * sets;
  }

  function extraCents(root) {
    var quote = quoteCents(root);
    var sets = setsQty(root);
    var base = variantCents(root) * sets;
    if (quote > base) return quote - base;
    if (quote > 0 && quote < base && isRangeBannerArea(root)) {
      /* Area below Size(ft) step: charge cheapest variant + adjust up to painted total. */
      try {
        syncCheapestVariant(root);
      } catch (errCheap) {}
      base = variantCents(root) * sets;
      if (quote > base) return quote - base;
    }
    return 0;
  }

  function ensureQuoteField(form) {
    var el = form.querySelector("[data-ezink-print-quote]");
    if (el) return el;
    el = document.createElement("input");
    el.type = "hidden";
    el.name = "properties[_print_quote]";
    el.setAttribute("data-ezink-print-quote", "");
    form.appendChild(el);
    return el;
  }

  function paint(root) {
    var form = root.querySelector("form[action*='/cart/add']") || root.querySelector("form.product-form");
    try {
      syncBannerVariant(root);
    } catch (errSync) {}
    var cents = quoteCents(root);
    if (!(cents > 0)) return 0;
    var fmt = moneyFormat(root);
    document.querySelectorAll("[data-ezink-price-total]").forEach(function (el) {
      el.hidden = false;
      el.textContent = formatMoney(cents, fmt);
    });
    var sets = setsQty(root);
    var each = sets > 0 ? Math.round(cents / sets) : cents;
    document.querySelectorAll("[data-ezink-price-unit]").forEach(function (el) {
      el.hidden = false;
      el.textContent = "(" + formatMoney(each, fmt) + " each)";
    });
    if (form) ensureQuoteField(form).value = String(cents);
    root.setAttribute("data-ezink-print-cents", String(cents));
    return cents;
  }

  function collectProps(fd) {
    var props = {};
    fd.forEach(function (val, key) {
      var m = String(key).match(/^properties\[([^\]]+)\]$/);
      if (m) props[m[1]] = String(val);
    });
    return props;
  }

  function addPrintThenAddon(form, root) {
    try {
      syncBannerVariant(root);
    } catch (errSync2) {}
    var extra = extraCents(root);
    var fd = new FormData(form);
    var id = fd.get("id");
    var qty = parseInt(fd.get("quantity") || "1", 10) || 1;
    var props = collectProps(fd);
    props["_print_quote"] = String(quoteCents(root));
    var wh = whInches(root);
    if (wh) {
      props["Width"] = String(wh.w);
      props["Height"] = String(wh.h);
    }
    var cover = coveringSizeLabel(root);
    if (cover) props["_covering_size_ft"] = cover;
    var addon = adjustVariant();
    if (extra > 0 && addon > 0 && !props["_Artwork set"]) {
      props["_Artwork set"] = "p" + Date.now().toString(36);
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: Number(id), quantity: qty, properties: props })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || "Could not add to cart");
          return body;
        });
      })
      .then(function () {
        if (!(addon > 0) || extra < 1) return;
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({
            id: addon,
            quantity: extra,
            properties: {
              _print_adjust: "1",
              "_Artwork set": props["_Artwork set"] || ""
            }
          })
        });
      })
      .then(function () {
        w.location.href = "/cart";
      });
  }

  function printRoots() {
    return document.querySelectorAll("[id^='ProductSection-'], [data-ezink-print-live='1']");
  }

  function paintAll() {
    printRoots().forEach(function (root) {
      if (root.querySelector("[data-ezink-print-combo-json]")) paint(root);
    });
  }

  function initRoot(root) {
    if (!root || root.getAttribute("data-ezink-print-price") === "1") return;
    if (!root.querySelector("[data-ezink-print-combo-json]")) return;
    root.setAttribute("data-ezink-print-price", "1");
    var form = root.querySelector("form[action*='/cart/add']") || root.querySelector("form.product-form");
    if (form) {
      form.addEventListener("submit", function (evt) {
        paint(root);
        if (!(extraCents(root) > 0) || !(adjustVariant() > 0)) return;
        evt.preventDefault();
        addPrintThenAddon(form, root).catch(function (err) {
          w.alert(err.message || "Could not add to cart");
        });
      });
    }
    setTimeout(function () {
      paint(root);
    }, 80);
    setTimeout(function () {
      paint(root);
    }, 400);
    setTimeout(function () {
      paint(root);
    }, 1200);
  }

  function boot() {
    printRoots().forEach(initRoot);
    if (document.documentElement.getAttribute("data-ezink-print-price-doc") === "1") return;
    document.documentElement.setAttribute("data-ezink-print-price-doc", "1");
    document.addEventListener(
      "change",
      function (evt) {
        var t = evt.target;
        if (!t) return;
        if (t.getAttribute && t.getAttribute("data-ezink-print-key")) {
          setTimeout(paintAll, 0);
          setTimeout(paintAll, 60);
          return;
        }
        if (t.classList && t.classList.contains("single-option-selector")) {
          setTimeout(paintAll, 0);
          setTimeout(paintAll, 60);
          return;
        }
        var name = t.getAttribute && t.getAttribute("name");
        if (name === "properties[Width]" || name === "properties[Height]") {
          setTimeout(paintAll, 0);
          setTimeout(paintAll, 80);
        }
      },
      true
    );
    document.addEventListener(
      "input",
      function (evt) {
        var t = evt.target;
        if (!t || !t.getAttribute) return;
        var name = t.getAttribute("name");
        if (name === "properties[Width]" || name === "properties[Height]") {
          setTimeout(paintAll, 0);
          setTimeout(paintAll, 80);
        }
      },
      true
    );
    document.addEventListener("ezink-print-combo", function () {
      setTimeout(paintAll, 0);
      setTimeout(paintAll, 30);
    });
    if (w.jQuery) {
      jQuery(document).on("variantChange", function () {
        setTimeout(paintAll, 40);
        setTimeout(paintAll, 200);
      });
    }
  }

  w.EZINKPrintPrice = {
    quoteCents: quoteCents,
    paint: paint,
    hasLadder: hasLadder,
    extraCents: extraCents,
    sqftRetailCents: sqftRetailCents,
    materialMult: materialMult,
    interpBannerRate: interpBannerRate,
    isRangeBannerArea: isRangeBannerArea,
    areaBaseCents: areaBaseCents
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
